// Both spellings appear in the data; the redemption list renders either.
const CANCELLED_STATUSES = ['Cancel', 'Cancelled'];

// Builds a card header such as
// "Redemption List (Total Request No:12.  Total Amount:$1,234,567)".
// Cancelled rows are excluded from both the count and the total.
export const buildListHeader = (
  label: string,
  records: Array<{ amount?: number | string; status?: string }> | null | undefined,
): string => {
  const rows = (records || []).filter(
    (row) => !CANCELLED_STATUSES.includes(row?.status || ''),
  );
  const total = rows.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0);
  return `${label} (Total Request No:${rows.length}.  Total Amount:$${total.toLocaleString('en-US')})`;
};
